/* @ngInject */
const go = (
  railwayLocal,
  $state,
  routes
) => {
  const self = {}

  self.new = () => {
    $state.go(routes.consult.railway.new.path)
  }

  self.consult = (_id) => {
    railwayLocal.saveCurrentId(_id)
    $state.go(routes.consult.railway.details.path)
  }

  self.edit = (_id) => {
    railwayLocal.saveCurrentId(_id)
    $state.go(routes.consult.railway.edit.path)
  }

  return self
}

export default go



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/services/go.service.js